import classNames from 'classnames';

import LoadingSvg from '@/assets/icons/loading-icon.svg?react';
import { isIdentityConsole } from '@/utils/cookies';

import MellowMark from '../../../../../toolkit/core-kit/assets/mellow-mark.svg?react';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

const LoadingIcon = ({ className }: Props) =>
  isIdentityConsole ? (
    <MellowMark
      aria-hidden
      width="24"
      height="24"
      className={classNames(styles.pulse, className)}
    />
  ) : (
    <LoadingSvg className={classNames(styles.loadingIcon, className)} />
  );

export default LoadingIcon;
